import OrderInformation from "../../../Components/Client/OrderInformation";

const OrderInformationPage = () => {
  return <OrderInformation />;
};

export default OrderInformationPage;
